// import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { GetSingleAdderMethod } from "../../Redux/AddersSlice/AddersSlice";
import { useDispatch, useSelector } from "react-redux";
import {
    GetSingleTicketsMethod,
    ticketsReset,
} from "../../Redux/TicketsSlice/TicketsSlice";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { Button, Card, CardActions, CardContent, Grid } from "@mui/material";
import TicketLead from "./Layouts/TicketLead";
import TicketSolution from "./Layouts/TicketSolution";
import JobCardDetails from "./Layouts/JobCardDetails";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import TicketProcedures from "./Layouts/TicketProcedures";
import TicketAttachments from "./Layouts/TicketAttachments";
import { OpenInNew } from "@mui/icons-material";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};

const bull = (
    <Box
        component="span"
        sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
    >
        •
    </Box>
);

const ShowTicket = () => {
    const dispatch = useDispatch();
    const { ticket_id } = useParams();
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { ticket, isLoading } = useSelector((state) => state.tickets);
    const ticketValue = ticket?.data;
    useEffect(() => {
        const GetSingleTicket = async () => {
            await dispatch(GetSingleTicketsMethod(ticket_id));
            await dispatch(ticketsReset());
        };
        GetSingleTicket();

        console.log(ticketValue);
    }, [ticket_id]);
    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <ShowContainer>
                    <Box className="basic-info" sx={{ padidng: "10px" }}>
                        <Typography variant="h4" align="center">
                            Basic Info
                        </Typography>
                        <hr></hr>
                        <Grid container spacing={1}>
                            <Grid item md={2} sm={6}>
                                <Typography variant="h6">
                                    {" "}
                                    Full Name :{" "}
                                </Typography>
                            </Grid>
                            <Grid item md={10} sm={6}>
                                <Typography variant="h6">
                                    {ticketValue?.ticket?.client_name}{" "}
                                </Typography>
                            </Grid>

                            <Grid item md={2} sm={6}>
                                <Typography variant="h6"> Email : </Typography>
                            </Grid>
                            <Grid item md={10} sm={6}>
                                <Typography variant="h6">
                                    {ticketValue?.ticket?.client_email}{" "}
                                </Typography>
                            </Grid>

                            <Grid item md={2} sm={6}>
                                <Typography variant="h6"> Phone : </Typography>
                            </Grid>
                            <Grid item md={10} sm={6}>
                                <Typography variant="h6">
                                    {ticketValue?.ticket?.client_phone}{" "}
                                </Typography>
                            </Grid>

                            <Grid item md={2} sm={6}>
                                <Typography variant="h6">
                                    {" "}
                                    Address :{" "}
                                </Typography>
                            </Grid>
                            <Grid item md={10} sm={6}>
                                <Typography variant="h6">
                                    {ticketValue?.ticket?.client_address}{" "}
                                </Typography>
                            </Grid>
                            {/* <Grid item md={4} sm={6}>
                                <Card sx={{ minWidth: "100%" }}>
                                    <CardContent>
                                        <Typography
                                            sx={{ fontSize: 14 }}
                                            color="text.secondary"
                                            gutterBottom
                                        >
                                            Word of the Day
                                        </Typography>
                                        <Typography
                                            variant="h5"
                                            component="div"
                                        >
                                            be{bull}nev{bull}o{bull}lent
                                        </Typography>
                                        <Typography
                                            sx={{ mb: 1.5 }}
                                            color="text.secondary"
                                        >
                                            adjective
                                        </Typography>
                                        <Typography variant="body2">
                                            well meaning and kindly.
                                            <br />
                                            {'"a benevolent smile"'}
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small">Learn More</Button>
                                    </CardActions>
                                </Card>
                            </Grid> */}
                        </Grid>
                    </Box>
                    <Box sx={{ width: "100%" }} mt={3}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                            >
                                <Tab label="Lead" {...a11yProps(0)} />
                                <Tab
                                    label="Job Card Details"
                                    {...a11yProps(1)}
                                />
                                <Tab label="Solution" {...a11yProps(2)} />
                                <Tab label="Attachments" {...a11yProps(3)} />
                                <Tab label="Procedures" {...a11yProps(4)} />

                                <a
                                    style={{ marginTop: "7px" }}
                                    href={
                                        "https://www.zillow.com/homes/" +
                                        ticketValue?.lead?.location
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <Button endIcon={<OpenInNew />} sx={{ color: "#9e9e9e" }}>
                                        Zillow
                                    </Button>
                                </a>
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <TicketLead ticketValue={ticketValue} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <JobCardDetails ticketValue={ticketValue} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <TicketSolution
                                solution={ticketValue?.opportunity}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <TicketAttachments ticketValue={ticketValue} />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <TicketProcedures
                                solution={ticketValue?.opportunity}
                            />
                        </TabPanel>
                    </Box>
                </ShowContainer>
            )}
        </>
    );
};

const ShowContainer = styled.div`
    .title {
        margin-top: 20px;
    }
    .text-gray {
        color: #737373;
    }
`;

// text-align: center;
export default ShowTicket;
